import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-top",
  "use": "icon-arrow-top-usage",
  "viewBox": "0 0 12 6",
  "content": "<symbol viewBox=\"0 0 12 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-top\">\r\n  <path d=\"M1.08838 5L6.08838 0.999999L11.0884 5\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol